import { useState, useEffect } from "react";

function HouseDesignDropdownModal({
  isOpen,
  onClose,
  houseDesigns,
  buyThisPlan,
  onSubmit,
}) {
  const [selectedId, setSelectedId] = useState("");
  const [selectedPriceKey, setSelectedPriceKey] = useState("");

  useEffect(() => {
    if (isOpen) {
      setSelectedId("");
      setSelectedPriceKey("");
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = () => {
    if (
      selectedId &&
      selectedPriceKey &&
      buyThisPlan &&
      buyThisPlan[selectedPriceKey]
    ) {
      onSubmit(selectedId, parseInt(buyThisPlan[selectedPriceKey]));
    }
  };

  const priceOptions = Object.entries(buyThisPlan || {}).filter(
    ([key]) => key !== "id" && key !== "name"
  );

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded shadow-md w-[400px]">
        <h3 className="text-lg font-semibold mb-4">Associate House Design</h3>

        <select
          value={selectedId}
          onChange={(e) => setSelectedId(e.target.value)}
          className="w-full p-2 mb-3 border rounded"
        >
          <option value="">Select House Design</option>
          {houseDesigns?.map((design) => (
            <option key={design.id} value={design.id}>
              {design.title || `House Design`}
            </option>
          ))}
        </select>

        <select
          value={selectedPriceKey}
          onChange={(e) => setSelectedPriceKey(e.target.value)}
          className="w-full p-2 mb-4 border rounded"
        >
          <option value="">Select Price</option>
          {priceOptions.map(([key, value]) => (
            <option key={key} value={key}>
              {`${key.replaceAll("_", " ")} - Rs. ${value}`}
            </option>
          ))}
        </select>

        <div className="flex justify-end space-x-2">
          <button
            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            onClick={handleSubmit}
          >
            Associate
          </button>
        </div>
      </div>
    </div>
  );
}

export default HouseDesignDropdownModal;
